import React from "react";
import { Form } from "react-bootstrap";

/**
 * TASK-19 · Autorización de tratamiento de datos (Ley 1581).
 *
 * Controlled, required checkbox shown on the registration forms. The parent
 * owns the boolean state and must block submit until it is checked.
 *
 * NOTE: registration is unauthenticated, so we do NOT call the authenticated
 * POST /api/v1/privacy/consent/ here — that endpoint is used post-login (see
 * usePrivacy / PrivacyPage). The checkbox enforces the consent gate in the UI;
 * persisting the consent record at onboarding time is a small backend follow-up
 * (coordinate with the onboarding serializers, TASK-06).
 */
export const PRIVACY_POLICY_VERSION = "2025-06";

function ConsentCheckbox({ checked, onChange, id = "privacy-consent" }) {
  return (
    <Form.Group className="mb-3" controlId={id}>
      <Form.Check
        type="checkbox"
        id={id}
        required
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        label={
          <span>
            Autorizo el tratamiento de mis datos personales conforme a la{" "}
            <a href="/politica-privacidad" target="_blank" rel="noreferrer">
              política de privacidad
            </a>
            .
          </span>
        }
      />
    </Form.Group>
  );
}

export { ConsentCheckbox };
